<!-- 大屏列表页面  -->
<template>
  <!-- 当前Tab是大屏 -->
  <div class="wallpaper-list_box" @click="handleClickWallpaperList()">
    大屏列表页面
    <div>
      {{ JSON.stringify(mWallpaperListConfig) }}
    </div>
  </div>
</template>
  
<script>


import emitter from '@/utils/eventbus';

export default {
  name: "WallpaperListPage",
  components: {

  },
  props: ['wallpaper_list_config'],
  data() {
    return {
      mWallpaperListConfig: this.wallpaper_list_config,
    }
  },
  methods: {
    /**
     * 点击大屏
     */
    handleClickWallpaperList() {
      console.log('handleClickWallpaperList', this.wallpaper_list_config)
      emitter.emit('onComponentChange', { name: "大屏列表", type: "wallpaper_list", component: this.wallpaper_list_config })
    }
  }
}
</script>
  
<style scoped lang="less">
.wallpaper-list_box {
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>